<script setup>
import {useRoute, useRouter} from "vue-router";
import {useSystem} from "../../store/system"
import {onActivated, onMounted, reactive, ref} from "vue";
import {useUser} from "../../store/user";
import {ElMessage} from "element-plus";

const router = useRouter()
const route = useRoute()
const userStore = useUser()
if (route.query.t) {
  userStore.setToken(route.query.t)
  router.push({path: '/'})
}

const systemStore = useSystem()
systemStore.systemInfoApi()

const website = systemStore.getWebsite

const submitLoading = ref(false)
const formData = reactive({
  email: "",
  password: ""
})

const loginSubmit = () => {
  if (!formData.email) {
    ElMessage({
      duration: 1500,
      message: "Email cannot be empty",
      type: 'error',
      onClose: () => {}
    })
    return
  }
  if (!formData.password) {
    ElMessage({
      duration: 1500,
      message: "Password cannot be empty",
      type: 'error',
      onClose: () => {}
    })
    return
  }

  submitLoading.value = true

  systemStore.emailLoginApi(formData, router)

  setTimeout(() => {
    submitLoading.value = false
  }, 1300)

}

onMounted(() => {
  // 动态雾霾效果
  if (document.querySelector('.section__canvas--second')) {
    VANTA.FOG({
      el: "#canvas2",
      mouseControls: true,
      touchControls: true,
      gyroControls: false,
      minHeight: 200.00,
      minWidth: 200.00,
      highlightColor: 0xA034FA,
      midtoneColor: 0xA034FA,
      lowlightColor: 0xE66C12,
      baseColor: 0x16142A,
      blurFactor: 0.90,
      speed: 5.70,
      zoom: 1.00
    })
  }
})

onActivated(() => {
  document.title = 'HexMiner Login | Access Your Cloud Mining Dashboard';
  document.querySelector('meta[name="description"]').setAttribute('content', 'Sign in to manage your crypto cloud mining portfolio, track\n' +
      'ROI, and withdraw earnings securely.');
})
</script>

<template>
  <div>
    <!-- page wrap -->
    <div class="section section--content">
      <div class="section__content">
        <!-- form -->
        <form action="#" class="form form--content">
          <div class="form__logo-wrap">
            <a href="/" class="form__logo">
              <img :src="website.website_logo" alt="">
            </a>
<!--            <span class="form__tagline">Arbitrage trading <br>HTML Template</span>-->
            <span class="form__tagline text-[20px]">{{ website.website_name }}</span>
          </div>

          <div class="form__group">
            <input type="text" class="form__input" placeholder="Email" v-model="formData.email">
          </div>

          <div class="form__group">
            <input type="password" class="form__input" placeholder="Login Password" v-model="formData.password">
          </div>

<!--          <div class="form__group form__group&#45;&#45;checkbox">-->
<!--            <input id="remember" name="remember" type="checkbox">-->
<!--            <label for="remember">Remember Me</label>-->
<!--          </div>-->
          <el-button :loading="submitLoading" class="section__btn tw-w-full justify-self-left" native-type="button" @click="loginSubmit">Sign in</el-button>

<!--          <span class="form__delimiter">or</span>-->

<!--          <div class="form__social">-->
<!--            <a class="fb" href="#"><i class="ti ti-brand-facebook"></i></a>-->
<!--            <a class="tw" href="#"><i class="ti ti-brand-x"></i></a>-->
<!--            <a class="gl" href="#"><i class="ti ti-brand-google"></i></a>-->
<!--          </div>-->

          <span class="form__text form__text--center">Don't have an account?
            <a href="Javascript:;" @click="router.push({path: '/Signup'})">Sign up!</a>
            <br>
            <a href="Javascript:;" @click="router.push({path: '/Forgot'})">Forgot password?</a>
          </span>

          <!-- design elements -->
          <span class="block-icon tw-cursor-pointer" @click="router.push({path: '/'})" :class="systemStore.getBlockIconColor()">
            <i class="ti ti-login"></i>
          </span>
          <span class="screw screw--big-tr"></span>
          <span class="screw screw--big-bl"></span>
          <span class="screw screw--big-br"></span>
        </form>
        <!-- end form -->
      </div>

      <!-- animation background -->
      <div class="top-0 left-0 bottom-0 w-full h-full section__canvas section__canvas--second" id="canvas2"></div>
    </div>
    <!-- end page wrap -->
  </div>
</template>

<style scoped>

</style>
